import React from 'react';
import { Link } from 'react-router-dom';

const GamesCtaSection = () => {
  return (
    <section aria-labelledby="games-cta-title">
      <div className="bg-gradient-to-br from-slate-50 via-white to-blue-50 p-8 rounded-xl border border-slate-200 shadow-lg site-card shadow-slate-200/70 text-center">
        <h2 id="games-cta-title" className="text-3xl font-bold text-gray-900">
          Quer sugerir um novo jogo?
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Estou aberto a ideias e feedbacks sobre os prototipos.
        </p>
        <div className="mt-8">
          <Link
            to="/contato"
            className="inline-flex items-center rounded-md bg-slate-800 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
          >
            Falar comigo
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GamesCtaSection;
